import request from '@/utils/request'

export function list(query) {
  return request({
    url: '/sys/dict/list',
    method: 'post',
    data: query
  })
}


export function add(bean) {
  return request({
    url: '/sys/dict/save',
    method: 'post',
    data: bean
  })
}

export function del(id) {
  return request({
    url: '/sys/dict/del',
    method: 'get',
    params: id
  })
}

export function update(bean) {
  return request({
    url: '/sys/dict/update',
    method: 'post',
    data: bean
  })
}

export function query(param) {
  return request({
    url: '/sys/dict/query',
    method: 'post',
    params: param
  })
}
